import { TRACKER_TYPES } from '../consts/trackers';
import type { RRDevicePosition, RRDeviceStatus, UbidiumDeviceStatus } from '../types/raceResult';
import { isEmptyString } from './utils';

export type RRDeviceTypes =
  | TRACKER_TYPES.RRDecoder
  | TRACKER_TYPES.RRTrackbox
  | TRACKER_TYPES.RRUbidium;

export const rrDeviceTypes: Array<RRDeviceTypes> = [
  TRACKER_TYPES.RRDecoder,
  TRACKER_TYPES.RRTrackbox,
  TRACKER_TYPES.RRUbidium,
];

export const filterRRDevicesByType = (
  devices: Array<RRDeviceStatus>,
  type: RRDeviceTypes,
): Array<RRDeviceStatus> => {
  return devices.filter((device) => {
    switch (type) {
      case TRACKER_TYPES.RRDecoder:
        return 'DeviceType' in device && device.DeviceType === 'Decoder';
      case TRACKER_TYPES.RRTrackbox:
        return 'DeviceType' in device && device.DeviceType === 'TrackBox';
      case TRACKER_TYPES.RRUbidium:
        return 'ConnStatus' in device;
      default:
        return false;
    }
  });
};

export const filterRRDevicesByCustomer = (
  devices: Array<RRDeviceStatus>,
  customerId: string,
): Array<RRDeviceStatus> => {
  return devices.filter((device) => device.Customer.toString() === customerId);
};

export function isRRDeviceType(deviceType: string): deviceType is RRDeviceTypes {
  return rrDeviceTypes.includes(deviceType as RRDeviceTypes);
}

export function isUbudiumDevice(device: RRDeviceStatus): device is UbidiumDeviceStatus {
  return 'ConnStatus' in device;
}

export const getRRDeviceId = (device: RRDeviceStatus): string => {
  if (isUbudiumDevice(device)) {
    return device.System.DeviceID;
  }
  return device.DeviceID;
};

export const getRRBatteryLevel = (device: RRDeviceStatus): number => {
  if (isUbudiumDevice(device)) {
    return device.Power.Battery1.Level;
  }
  return device.BatteryCharge;
};

export const getRRConnectionStatus = (device: RRDeviceStatus): boolean => {
  if (isUbudiumDevice(device)) {
    return device.ConnStatus === 1 || device.ConnStatus === 2;
  }
  return device.Connected;
};

export const getRRPosition = (
  device: RRDeviceStatus,
): RRDevicePosition & { Flag: 'U' | 'S' | 'M' | 'T' | 'X' } => {
  if (isUbudiumDevice(device)) {
    return {
      ...device.Position,
      Flag: isEmptyString(device.Position.Flag) ? 'S' : device.Position.Flag,
    } as RRDevicePosition & { Flag: 'U' | 'S' | 'M' | 'T' | 'X' };
  }

  return device.Position as RRDevicePosition & { Flag: 'U' | 'S' | 'M' | 'T' | 'X' };
};
